// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1ULyY-hxl9rX_oSPxoeoV2"};